import React from 'react';
import { Link } from 'react-router-dom';
import {
  DropdownToggle, UncontrolledDropdown,
} from 'reactstrap';


const TopbarIotService = ({t}) => (
  <UncontrolledDropdown className="d-md-down-none">
    <DropdownToggle >
        <i className="fa fa-binoculars" aria-hidden="true"/>
      <Link to="/iotservice">IOT</Link>
    </DropdownToggle>
  </UncontrolledDropdown>
);

export default TopbarIotService;



// WEBPACK FOOTER //
// ./src/containers/TopbarIotService.jsx